function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M48.9,58.7c-7,0-12.8-5.7-12.8-12.8V6.1h3.1v39.8c0,5.3,4.3,9.7,9.7,9.7s9.7-4.3,9.7-9.7V6.1h3.1v39.8 C61.6,53,55.9,58.7,48.9,58.7z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M48.9,65.8c-11,0-19.9-8.9-19.9-19.9V6.1H32v39.8c0,9.3,7.6,16.8,16.8,16.8s16.8-7.6,16.8-16.8V6.1h3.1v39.8 C68.8,56.9,59.9,65.8,48.9,65.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M48.9,73c-14.9,0-27-12.1-27-27V6.1h3.1v39.8c0,13.2,10.8,24,24,24s24-10.8,24-24V6.1h3.1v39.8 C75.9,60.8,63.8,73,48.9,73z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M48.9,51.5c-3.1,0-5.6-2.5-5.6-5.6V6.1h3.1v39.8c0,1.4,1.1,2.6,2.6,2.6s2.6-1.1,2.6-2.6V6.1h3.1v39.8 C54.5,49,52,51.5,48.9,51.5z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "23.8,45 12.8,45 12.8,13 23.8,13 23.8,16 15.8,16 15.8,42 23.8,42  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "83.8,45 73.8,45 73.8,42 80.8,42 80.8,16 74.8,16 74.8,13 83.8,13  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 22.8,
  y: 97,
  width: 53,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 43.8,
  y: 72,
  width: 3,
  height: 20
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 50.8,
  y: 72,
  width: 3,
  height: 20
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 22.8,
  y: 91,
  width: 53,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 22.8,
  width: 53,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 22.8,
  y: 6,
  width: 52,
  height: 3
})))));

var SvgTrophy = function SvgTrophy(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/trophy.36990f91.svg";
export { SvgTrophy as ReactComponent };